import { catchError, OperatorFunction, of } from 'rxjs';

import { ToastService } from './toast.service';

/** RxJS operator to use inside pipe() that will convert any error to a new value returned from `callback()` and show a toast with a generic error message */
export function showGenericErrorToast<T, O>(
  toastService: ToastService,
  callback: (error: unknown) => O,
  error?: string,
): OperatorFunction<T, T | O> {
  return catchError((e) => {
    console.error(e);
    toastService.showError(error ?? e);
    return of(callback(e));
  });
}
